import React, { useMemo, useCallback } from 'react'
import { Stack } from '@mui/material'
import ScrollTable from 'components/global/CUK/ScrollTable'
import TableView, { useTable } from 'packages/ui/Table'
import { ResponsiveTableProvider } from 'packages/ui/Table'
import { useResponsiveTable } from 'packages/ui/Table'
import useSort from '../../hooks/use-sort'
import COLUMNS_CONFIG_CENTER, { ExpandedRowDetails } from './config-columns-center'
import { useUser } from 'store'

const RESPONSIVE_COLUMNS_CONFIG = {
  mobile: ['step', 'label', 'site_name', 'created_at', 'actions'],
  tablet: ['step', 'label', 'site_name', 'created_at', 'type', 'format', 'actions'],
  desktop: ['step', 'label', 'type', 'account', 'site_name', 'created_at', 'updated_at', 'format', 'actions'],
  desktopLarge: ['step', 'label', 'type', 'account', 'site_name', 'created_at', 'updated_at', 'format', 'actions']
}

const CenterTable = ({ documentSelected, queryDocuments, onRowClick }) => {
  const [user] = useUser();
  const apiSort = useSort({
    onChange: queryDocuments?.refetch,
  });

  const expandedRowConfig = useMemo(() => ({
    component: ExpandedRowDetails,
    shouldRender: (screenSize) => screenSize === 'mobile',
    fields: []
  }), [])

  const { filteredColumns, responsiveConfig } = useResponsiveTable(
    RESPONSIVE_COLUMNS_CONFIG,
    COLUMNS_CONFIG_CENTER,
    {
      excludeColumns: documentSelected ? ['updated_at', 'account'] : []
    },
    expandedRowConfig
  )

  const allDocuments = useMemo(() => {
    return (queryDocuments?.data?.documents || []).map(doc => ({
      ...doc,
      site_name: doc.site_name || (doc.sites && doc.sites[0]?.name),
    }));
  }, [queryDocuments?.data?.documents]);

  const sortedDocuments = useMemo(() => {
    return apiSort.sort(allDocuments);
  }, [allDocuments, apiSort]);

  const handleRowClick = useCallback((doc) => {
    if (user.admin || (user.roles && user.roles.wifirst_documents)) {
      onRowClick(doc);
    }
  }, [user.roles, onRowClick]);

  const apiTable = useTable({
    rowKey: 'id',
    loading: queryDocuments?.loading,
    items: sortedDocuments,
    columns: filteredColumns,
    onRowClick: handleRowClick,
    responsiveConfig
  });

  return (
    <ResponsiveTableProvider>
      <Stack
        sx={{
          overflow: 'hidden',
          overflowY: 'auto',
          flex: '1 1 auto',
          scrollbarWidth: 'none',
          height: '100%',
          '&::-webkit-scrollbar ': {
            display: 'none',
          },
        }}
      >
        <ScrollTable
          fetchNextPage={queryDocuments?.fetchNextPage}
          shouldFetchNextPage={queryDocuments?.shouldFetchNextPage}
          refetch={queryDocuments?.refetch}
          collapse={Boolean(documentSelected)}
        >
          <TableView
            apiTable={apiTable}
            sort={{
              by: apiSort.orderBy,
              direction: apiSort.orderDirection,
              onChange: (name) => {
                const column = filteredColumns.find((column) => column.name === name);
                apiSort.orderByChange(column.sortBy || column.name);
              },
            }}
          />
        </ScrollTable>
      </Stack>
    </ResponsiveTableProvider>
  );
};

export default CenterTable;